var React = require('react');

function Paschange (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_70229","data-name":"Group 70229","transform":"translate(-770.25 -509.114)"},React.createElement("g",{"id":"Icon_feather-edit-3","data-name":"Icon feather-edit-3","transform":"translate(766.5 505.682)"},[React.createElement("path",{"id":"Path_253","data-name":"Path 253","d":"M18,30h6.308","transform":"translate(-7.192 -13.682)","fill":"none","stroke":"#686868","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5","key":0}),React.createElement("path",{"id":"Path_254","data-name":"Path 254","d":"M13.962,4.753a1.487,1.487,0,1,1,2.1,2.1L7.3,15.617l-2.8.7.7-2.8Z","transform":"translate(0 0)","fill":"none","stroke":"#686868","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5","key":1})])));
}

Paschange.defaultProps = {"width":"14.116","height":"13.636","viewBox":"0 0 14.116 13.636"};

module.exports = Paschange;

Paschange.default = Paschange;
